import React from 'react';
import styled, { css } from 'styled-components';
import { jsConfetti } from '../utils/confetti';
import { useGame } from '../providers/GameProvider/GameProvider';
import { randomItem } from '../utils';
import { Tube } from './layout/Tube';
import { Button } from './core';

const winMessages = [
  "Yes we're going to a party, party!",
  "The sun is up, the sky is blue, it's beautiful and so are you!",
  'You know you should be glad!',
  'How does it feel to be one of the beautiful people?',
  'Getting so much better all the time!',
  'Pick up the bags and get in the limousine',
  "I'm sorry that I doubted you, I was so unfair",
];

const loseMessages = [
  'My tears are falling like rain from the sky',
  'You made a fool of everyone',
  "Go away, leave me alone, don't bother me",
  "What you need's a damn good whacking",
  "Oh, you can't do that",
  'Try thinking more, if just for your own sake',
  'What goes on in your mind?',
];

const Container = styled.div(
  ({ theme }) => css`
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background: ${theme.paper.default}DD;
    padding: 1rem;
  `
);

const Text = styled.p(
  ({ theme }) => css`
    position: relative;
    color: ${theme.text.default};
    font-weight: 700;
    text-align: center;
    font-size: 2.5rem;
    margin: 0;

    @keyframes wobble {
      0% {
        opacity: 0;
        transform: translateX(0%);
        transform-origin: 50% 50%;
      }

      15% {
        opacity: 1;
        transform: translateX(-30px) rotate(-6deg);
      }

      30% {
        transform: translateX(15px) rotate(6deg);
      }

      45% {
        transform: translateX(-15px) rotate(-3.6deg);
      }

      60% {
        transform: translateX(9px) rotate(2.4deg);
      }

      75% {
        transform: translateX(-6px) rotate(-1.2deg);
      }
      100% {
        transform: translateX(0%);
        transform-origin: 50% 50%;
      }
    }

    animation: wobble 2s ease 0s 1 normal forwards;
  `
);

const CloseButton = styled.button(
  ({ theme }) => css`
    cursor: pointer;
    border: solid 1px ${theme.border.default};
    border-radius: 0.5rem;
    width: min-content;
    padding: 0.5rem;
    color: ${theme.text.default};
    background: ${theme.paper.default};
    position: absolute;
    right: 1rem;
    top: 1rem;

    &:hover {
      background: ${theme.paper.hover};
    }
  `
);

export function GameOver() {
  const { gameState, handleContinue } = useGame();
  const [visible, setVisible] = React.useState(true);

  React.useEffect(() => {
    if (gameState === 'won') {
      jsConfetti.addConfetti({
        confettiColors: ['#BC5E92', '#CCC964', '#3BADBF', '#B42820'],
      });
    }
  }, [gameState]);

  function handleContainerClick(event: React.MouseEvent) {
    if (event.target === event.currentTarget) {
      setVisible(false);
    }
  }

  if (gameState === 'playing' || gameState === 'continue' || !visible)
    return null;

  return (
    <Container onClick={handleContainerClick}>
      <CloseButton onClick={handleContainerClick}>Close</CloseButton>

      {gameState === 'won' && <Text>{randomItem(winMessages)}</Text>}

      {gameState === 'lost' && (
        <Tube align="center" justify="center" gap="2rem">
          <Text>{randomItem(loseMessages)}</Text>
          <Button onClick={handleContinue}>Keep playing for fun?</Button>
        </Tube>
      )}
    </Container>
  );
}
